module.exports = __webpack_public_path__ + "static/media/office_space.2e32b8a3.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/office_space.png
// module id = 801
// module chunks = 0